import React from "react";
import {BaseThatsMeIconProps} from "../../interfaces/baseThatsMeIconProps.interface";

export default (props: BaseThatsMeIconProps) => {
    const {size = 24, ...rest} = props;
    return <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <rect x="0.5" y="4.5" width="27" height="21" fill="#83FFAD" stroke="black"/>
        <path
            d="M13.1311 21.192C12.0325 21.192 11.1898 20.8827 10.6031 20.264C10.0165 19.6347 9.72314 18.7707 9.72314 17.672H11.0831C11.0938 18.3013 11.2591 18.84 11.5791 19.288C11.8991 19.7253 12.4111 19.944 13.1151 19.944C13.8191 19.944 14.3205 19.7307 14.6191 19.304C14.9285 18.8773 15.0831 18.344 15.0831 17.704V9.79999H16.4271V17.704C16.4271 18.824 16.1391 19.688 15.5631 20.296C14.9871 20.8933 14.1765 21.192 13.1311 21.192Z"
            fill="black"/>
        <rect x="0.5" y="0.5" width="10" height="4" fill="#83FFAD" stroke="black"/>
    </svg>
}
